(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vox-single-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vox-image-carousel')) {
  customElements.define('vox-image-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-vox-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-vox-dot]'));
      this.currentSlide = 0;
      this.timer = null;
      this.querySelector('[data-vox-previous]')?.addEventListener('click', () => this.show(this.currentSlide - 1, true));
      this.querySelector('[data-vox-next]')?.addEventListener('click', () => this.show(this.currentSlide + 1, true));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.currentSlide + 1, true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.currentSlide - 1, true); }
      });
      const brandOptions = this.closest('.vox2026')?.querySelectorAll('.vox2026-variants input[name="id"]') || [];
      brandOptions.forEach((option) => option.addEventListener('change', () => {
        if (option.checked) this.show(option.closest('label')?.textContent.includes('Lexus') ? 2 : 1, true);
      }));
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    show(index, manual) {
      if (!this.slides || !this.slides.length) return;
      this.currentSlide = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.currentSlide;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-current', i === this.currentSlide);
        dot.setAttribute('aria-current', String(i === this.currentSlide));
      });
      if (manual) { this.stop(); this.start(); }
    }
    start() {
      if (this.timer || !this.isConnected || document.hidden || this.matches(':hover') || this.contains(document.activeElement) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = window.setInterval(() => this.show(this.currentSlide + 1, false), 6000);
    }
    stop() { if (this.timer) { window.clearInterval(this.timer); this.timer = null; } }
  });
}

(function () {
  const initVoxMotion = () => {
    const root = document.querySelector('.vox2026');
    if (!root || root.dataset.voxMotionInitialized === 'true') return;
    root.dataset.voxMotionInitialized = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!reduced.matches && fine.matches) {
      root.querySelectorAll('[data-vox-tilt]').forEach((target) => {
        let frame = 0;
        let lastX = 0;
        let lastY = 0;
        target.addEventListener('pointermove', (event) => {
          lastX = event.clientX;
          lastY = event.clientY;
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = 0;
            const bounds = target.getBoundingClientRect();
            if (!bounds.width || !bounds.height) return;
            const dx = Math.min(1, Math.max(-1, ((lastX - bounds.left) / bounds.width - 0.5) * 2));
            const dy = Math.min(1, Math.max(-1, ((lastY - bounds.top) / bounds.height - 0.5) * 2));
            target.style.setProperty('--vox-tilt-x', (-dy * 4.5).toFixed(2) + 'deg');
            target.style.setProperty('--vox-tilt-y', (dx * 6).toFixed(2) + 'deg');
          });
        }, {passive: true});
        target.addEventListener('pointerleave', () => {
          if (frame) window.cancelAnimationFrame(frame);
          frame = 0;
          target.style.setProperty('--vox-tilt-x', '0deg');
          target.style.setProperty('--vox-tilt-y', '0deg');
        });
      });
    }
    if (!reduced.matches && 'IntersectionObserver' in window) {
      const reveal = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('vox-motion-revealed');
          observer.unobserve(entry.target);
        });
      }, {threshold: 0.1});
      root.querySelectorAll('[data-vox-motion-reveal]').forEach((node) => reveal.observe(node));
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVoxMotion, {once: true});
  } else {
    initVoxMotion();
  }
})();


(function () {
  const setUpVoxVideo = () => {
    document.querySelectorAll('.vox2026 .vox-video-stage').forEach((stage) => {
      if (stage.dataset.initialized) return;
      stage.dataset.initialized = '1';
      const player = stage.querySelector('video');
      const replay = stage.querySelector('[data-vox-video-play]');
      if (!player) return;
      player.controls = true;
      player.playsInline = true;
      player.muted = true;
      player.loop = true;
      player.preload = 'metadata';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        player.autoplay = false;
        player.removeAttribute('autoplay');
        player.pause();
      } else {
        player.play().catch(() => {});
      }
      replay?.addEventListener('click', () => {
        if (player.paused) {
          const result = player.play();
          if (result && typeof result.catch === 'function') result.catch(() => {});
        } else {
          player.pause();
        }
      });
      player.addEventListener('error', () => {
        if (replay) replay.textContent = 'Use video link ↗';
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUpVoxVideo, {once:true});
  } else {
    setUpVoxVideo();
  }
})();


  } catch(e) { console.error(e); }
})();
})();
